import { Card, Grid, Stack } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { IConsultant } from 'wisestep-api';
import {
  CardVariant,
  Item,
  WsCard,
  WsIconCalendarOutline,
  WsIconEducation,
  WsIconJobOutline,
  WsIconLocation,
  WsIconText,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

interface IActiveConsultantInfo {
  consultantData?: IConsultant;
}

const ActiveConsultantInfo = ({ consultantData }: IActiveConsultantInfo) => (
  <Stack p={1}>
    <WsCard
      title={consultantData?.name ?? ''}
      isButton={false}
      cardType={CardVariant.WITH_LIGHT_BG}
      middleComponent={
        <Stack direction="row">
          <Item>
            <WsIconText
              icon={<WsIconLocation />}
              text={consultantData?.location?.country ?? 'Not Available'}
              popOverText="Consultant Location"
              textSize={WsTypoVariants.SUB_TITLE}
            />
          </Item>
          <Item>
            <WsIconText
              icon={<WsIconJobOutline />}
              text={consultantData?.jobTitle ?? 'Not Available'}
              popOverText="Current Job Title"
              textSize={WsTypoVariants.SUB_TITLE}
            />
          </Item>
          <Item>
            <WsIconText
              icon={<WsIconCalendarOutline />}
              text={consultantData?.totalYearsExperience ?? 'Not Available'}
              popOverText="Experience (Years)"
              textSize={WsTypoVariants.SUB_TITLE}
            />
          </Item>
          <Item>
            <WsIconText
              icon={<WsIconEducation />}
              text={consultantData?.education ?? 'Not Available'}
              popOverText="Education"
              textSize={WsTypoVariants.SUB_TITLE}
            />
          </Item>
        </Stack>
      }
    />
    <Grid container display={'flex'} mt={1} spacing={2} p={1}>
      <Grid item xs={6}>
        <Card>
          <Item sx={{ display: 'flex', justifyContent: 'center' }}>
            <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
              {consultantData?.name}&apos;s Preferences
            </WsTypography>
          </Item>
          <Item>
            <WsTypography>
              <b>Pay/Hour:</b> {consultantData?.salaryPerHour ?? 'Not Available'}
            </WsTypography>
          </Item>
          <Item>
            <WsTypography>
              <b>Willing To Relocate:</b>
              {!isEmpty(consultantData?.willingToRelocate)
                ? consultantData?.willingToRelocate
                  ? 'Yes'
                  : 'No'
                : 'Not Available'}
            </WsTypography>
          </Item>
          <Item>
            <WsTypography>
              <b>Visa Status:</b> {consultantData?.visaStatus ?? 'Not Available'}
            </WsTypography>
          </Item>
          <Item>
            <WsTypography>
              <b>Availability</b>: {consultantData?.availability ?? 'No Info'}
            </WsTypography>
          </Item>
        </Card>
      </Grid>
      <Grid item xs={6}>
        <Card>
          <Item sx={{ display: 'flex', justifyContent: 'center' }}>
            <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
              Contact Information
            </WsTypography>
          </Item>
          <Item>
            <WsTypography>
              <b>Name:</b> {consultantData?.ownerName ?? 'Not Available'}
            </WsTypography>
          </Item>
          <Item>
            <WsTypography>
              <b>Email:</b>
              {consultantData?.ownerId.substring(0, 2) +
                'xxxx@xxxxx' +
                consultantData?.ownerId.substring(consultantData?.ownerId.lastIndexOf('.')) ??
                'Not Available'}
            </WsTypography>
          </Item>
          <Item>
            <WsTypography>
              <b>Phone:</b> {consultantData?.ownerPhone ?? 'Not Available'}
            </WsTypography>
          </Item>
          <Item>
            <WsTypography>
              <b>Company:</b> {consultantData?.ownerCompany ?? 'Not Available'}
            </WsTypography>
          </Item>
        </Card>
      </Grid>
    </Grid>
  </Stack>
);

export default ActiveConsultantInfo;
